import repository from '@/utils/repository';

const resource = '/move/MNG_System004';

export default {
    storeSave: (data) => {
        return repository.post(`${resource}/save`, {
            ...data
        });
    },
    getMessageConfirm: (data) => {
        return repository.post(`${resource}/getMessageConfirm`, {
            ...data
        });
    }
};
